var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSerieNotas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.792,
    height: 11.624,
    viewBox: "0 0 14.792 11.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rectangles",
    transform: "translate(0 -31.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2234",
    "data-name": "Caminho 2234",
    d: "M9.494,33.861V32.718a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v3.84a1,1,0,0,0,1,1h.736V35.61a1.752,1.752,0,0,1,1.749-1.749Z",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2235",
    "data-name": "Caminho 2235",
    d: "M59.27,91.769V90.626a1,1,0,0,0-1-1H50.776a1,1,0,0,0-1,1v3.839a1,1,0,0,0,1,1h1.063V93.518a1.751,1.751,0,0,1,1.749-1.749Z",
    transform: "translate(-47.29 -55.016)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2236",
    "data-name": "Caminho 2236",
    d: "M114.581,147.533h-7.493a1,1,0,0,0-1,1v3.84a1,1,0,0,0,1,1h7.493a1,1,0,0,0,1-1v-3.84A1,1,0,0,0,114.581,147.533Z",
    transform: "translate(-100.789 -110.031)",
    fill: "#64c2c8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerieNotas);
export default __webpack_public_path__ + "static/media/serieNotas.de67208f67805ed28696df334ede11c1.svg";
export { ForwardRef as ReactComponent };